import { render, staticRenderFns } from "./jcfx.vue?vue&type=template&id=3a291d52&scoped=true&"
import script from "./jcfx.vue?vue&type=script&lang=js&"
export * from "./jcfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a291d52",
  null
  
)

export default component.exports